import { auth } from "@/protos";
import { AUTH_SERVICE_URL } from "@/configs";
import { AuthModule } from "@/store/auth";

export class AuthClient {
  private static instance: AuthClient;

  private constructor() {
    console.log("In Auth Client");
  }

  static getInstance(): AuthClient {
    if (!AuthClient.instance) {
      AuthClient.instance = new AuthClient();
    }

    return AuthClient.instance;
  }

  async signIn(signInType: auth.SignInType.Enum, authToken: string): Promise<void> {
    const data = new auth.SignInRequest({
      domainName: auth.DomainName.Enum.HURRYUP,
      signInType: signInType,
      authToken: authToken,
    });

    const request = auth.SignInRequest.create(data);
    const response = await this.callApi(`${AUTH_SERVICE_URL}/SignIn`, JSON.stringify(request));
    const result = auth.SignInResponse.create(response.data);

    await this._handleSignIn(result);
  }

  async signInAnonymous(): Promise<void> {
    //await this.signIn(auth.SignInType.Enum.ANONYMOUS, "");
  }

  private async _handleSignIn(result: auth.ISignInResponse | auth.ISignUpResponse): Promise<void> {
    if (result.user && result.authCredential) {
      await AuthModule.update({
        user: result.user,
        credentials: result.authCredential,
      });
    }
  }

  public async signOut(): Promise<void> {
    await AuthModule.clear();
  }

  /*-------------------------------------------------------------------------*\
  |                            API Call                                 |
  \*-------------------------------------------------------------------------*/
  async callApi(url: string, data: string): Promise<any> {
    const response = await window.axios({
      method: "POST",
      url,
      data,
      headers: {
        accept: "application/json",
        contentType: "application/json",
      },
    });
    if (!response.data) {
      throw new Error("Empty response");
    }
    return response;
  }
}
